<div class="campaign-process-container d-flex align-items-center justify-content-start" style="flex-direction: column;">
    <div class="campaign-process-index">{{index}}</div>
    <div style="font-size: 24px; font-weight: bold; margin: 10px 0px;">
        {{label}}
    </div>
    <div style="padding: 0 30px; font-size: 16px;">
        {{content}}
    </div>
</div>